/**
 * @fileoverview Settings Layout
 *
 * Purpose: Settings layout wrapper. Navigation is handled in the sidebar.
 * URL: /dashboard/settings/*
 * Protection: Requires authentication
 */

import {
  createFileRoute,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import { cn } from "@/utils/misc";

export const Route = createFileRoute("/_app/_auth/dashboard/_layout/settings")({
  component: DashboardSettingsLayout,
  beforeLoad: () => ({
    headerTitle: "Settings",
  }),
});

export default function DashboardSettingsLayout() {
  // The report-template editor is a three-column workspace (contents rail,
  // sections, assistant) — give it the full window instead of the centred
  // settings column.
  const fullBleed = useRouterState({
    select: (s) => s.location.pathname.includes("/settings/report-templates"),
  });
  return (
    <div className="flex h-full w-full flex-col bg-muted">
      <div
        className={cn(
          "mx-auto flex w-full flex-1 flex-col p-6",
          !fullBleed && "max-w-screen-2xl",
        )}
      >
        <Outlet />
      </div>
    </div>
  );
}
